import React, { Fragment } from 'react';
import '../styles/Footer.css';

const Footer = ({ 
  paginaActual, 
  paginaAnterior, 
  paginaSiguiente, 
  handleSubmit,
  aceptaTerminos,
  enviandoFormulario
}) => {
  return (
    <Fragment>
      <div className="footer-container">
      <button
        onClick={paginaAnterior}
        disabled={paginaActual === 1 || enviandoFormulario}
        className={`btn-nav btn-nav-prev ${paginaActual === 1 || enviandoFormulario ? 'disabled' : ''}`}
      >
        Anterior
      </button>

      <div className="footer-actions">
        {paginaActual === 5 ? (
          <button
            onClick={handleSubmit}
            disabled={enviandoFormulario}
            className={`btn-nav btn-nav-next ${enviandoFormulario ? 'disabled' : ''}`}
          >
            {enviandoFormulario ? (
              <>
                <span className="spinner"></span>
                Enviando datos...
              </>
            ) : (
              'Enviar Registro'
            )}
          </button>
        ) : (
          <button
            onClick={paginaSiguiente}
            disabled={(paginaActual === 1 && !aceptaTerminos) || enviandoFormulario}
            className={`btn-nav btn-nav-next ${(paginaActual === 1 && !aceptaTerminos) || enviandoFormulario ? 'disabled' : ''}`}
          >
            {enviandoFormulario ? (
              <>
                <span className="spinner"></span>
                Procesando...
              </>
            ) : (
              paginaActual === 5 ? 'Enviar' : 'Siguiente'
            )}
          </button>
        )}
      </div>
    </div>
    
    {/* Nota de desarrollo */}
    <div style={{
      textAlign: 'center',
      marginTop: '1rem',
      padding: '0.5rem',
      fontSize: '0.75rem',
      fontWeight: 'bold',
      color: '#6b7280',
      borderTop: '1px solid #e5e7eb'
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        gap: '0.5rem',
        flexWrap: 'wrap' // Para móvil
      }}>
        <span>Desarrollado por</span>
        <img
          src="/dev_logo.png"
          alt="DEV•JAH•VUH Technologies"
          style={{
            width: '20px',
            height: '20px',
            verticalAlign: 'middle',
            flexShrink: '0' // Evitar que el logo se encoja
          }}
        />
        <span style={{ color: '#3A7D5C', fontWeight: 'bold' }}>DEV•JAH•VUH</span>
        <span style={{ color: '#3A7D5C' }}>Technologies.</span> Todos los derechos reservados.
      </div>
    </div>
    </Fragment>
  );
};

export default Footer;
